var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cassie-vertical-md"},[_c('TextField',{attrs:{"value":_vm.item[_vm.nameKey],"label":"Name *","rules":"required"},on:{"input":function($event){return _vm.updateItem(_vm.nameKey, $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }